import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11.188 20.465a.5.5 0 0 0 .493.505c.17.002.343.003.516.003 3.326 0 6.125-.353 8.4-1.064a1.997 1.997 0 0 0 1.376-2.234l-.422-2.534a3.495 3.495 0 0 0-3.146-2.909 72.16 72.16 0 0 0-6.738-.246.5.5 0 0 0-.497.502c.58 1.262 2.58 4.012.018 7.977Zm1.24-11.477c-13.329 0 12.828 0 0 0ZM7.435 4.994a4.993 4.993 0 1 1 9.986-.001 4.993 4.993 0 0 1-9.986 0ZM0 16.479a5.493 5.493 0 1 1 10.985-.001 5.493 5.493 0 0 1-10.985 0Zm6.487.465-1.14 1.152a.482.482 0 0 0 .007.686.491.491 0 0 0 .69-.007l1.954-1.976a.482.482 0 0 0-.003-.682L6.04 14.18a.491.491 0 0 0-.69 0 .482.482 0 0 0 0 .685l1.12 1.111H3.193c-.205 0-.372.217-.372.485 0 .267.167.484.372.484h3.294Z",
      clipRule: "evenodd"
    }
  )
);
var SvgAssignedFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AssignedFilled_default = SvgAssignedFilled;

export { AssignedFilled_default as default };
